import '../styles.scss'
import { Chat } from '../Chat/Chat'
import { ChatHeader } from '../ChatHeader/ChatHeader'
import { Conversations } from '../Conversations/Conversations'
import { FilterForm } from '../FilterForm/FilterForm'
import { QuickActions } from '../QuickActions'
import { ResumeButton } from '../ResumeButton'
import css from './Mailbox.module.scss'

export function Mailbox() {
	return (
		<div className={css.wrapper}>
			<div className={css.side}>
				<FilterForm />
				<Conversations />
			</div>
			<QuickActions />
			<main className={css.main}>
				<ChatHeader />
				<Chat />
			</main>

			<div className={css.future}>
				<ResumeButton />
			</div>
		</div>
	)
}
